{
  "version": 1,
  "asset_id": "a5a62634-5620-45bf-a43b-9047616222cd",
  "project_id": "160b2239-3b67-4000-8b6e-d774982b0968",
  "url": "/__l5e/assets-v1/a5a62634-5620-45bf-a43b-9047616222cd/dr-sara-portrait.jpg",
  "r2_key": "a/v1/160b2239-3b67-4000-8b6e-d774982b0968/a5a62634-5620-45bf-a43b-9047616222cd/dr-sara-portrait.jpg",
  "original_filename": "dr-sara-portrait.jpg",
  "size": 56943,
  "content_type": "image/jpeg",
  "created_at": "2026-10-27T15:14:39Z"
}
